<template>
  <div></div>
</template>

<script setup lang="ts">
const loadJivoSite = () => {
  const widget_id = 'mGbuZU6gEA';

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = `//code.jivosite.com/script/geo-widget/${ widget_id }`;
  document.head.appendChild(script);
}
onMounted(() => {
  // Грузим чат только когда главный поток свободен (requestIdleCallback), а не по фикс. таймеру (дешевая защита inp):
  // бандл JivoSite (~900мс парсинга) блокирует любой тап, если запустить его в разгар взаимодействия.
  // Safari не поддерживает requestIdleCallback — там фолбэк на setTimeout.
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    (window as any).requestIdleCallback(loadJivoSite, { timeout: 15000 });
  } else {
    setTimeout(loadJivoSite, 10000);
  }
});
</script>

<style scoped lang="scss">

</style>
